<template>
  <article class="live-comment-animation" ref="wrapper">
    <!-- <section class="paid-comment">
    </section> -->
    <section class="room-warning-container">
      <transition name="fade">
        <room-warning v-if="isWarningVisible" :warning="warning" />
      </transition>
    </section>
    <section class="gift-combos-container">
      <transition-group name="combo" tag="ul">
        <li v-for="(combo, index) in combos" :key="combo?.comboId" :class="`rank-${index + 1}`">
          <gift-combo :combo="combo"/>
        </li>
      </transition-group>
    </section>
  </article>
</template>

<script lang="ts" setup>
import { toRef } from 'vue';
import useCombo from './combo/composables/use-combo';
import GiftCombo from './combo/gift-combo.vue';
import useWarning from './warning/composables/use-warning';
import RoomWarning from './warning/room-warning.vue';

const comboContext = useCombo();
const combos = toRef(comboContext, 'combos');

const warningContext = useWarning();
const warning = toRef(warningContext, 'warning');
const isWarningVisible = toRef(warningContext, 'isVisible');
</script>


<style lang="less" scoped>
@import '@/styles/var.less';

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.live-comment-animation {
  position: absolute;
  z-index: @rightBar_layer_index_animation;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  .room-warning-container {
    position: absolute;
    z-index: @rightBar_layer_index_animation_warning;
    background-color: transparent;
    top: 10px;
    left: 12px;
    right: 12px;
    border-radius: 6px;
    pointer-events: none;
  }

  .gift-combos-container{
    position: relative;
    z-index: @rightBar_layer_index_animation_combo;

    & > ul {
      padding: 8px 12px;
      position: relative;

      & > li {
        position: absolute;
        left: 8px 12px;
        transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
        transition-duration: 0.3s;
        transition-property: transform, opacity;
        opacity: 1;

        @comboHeight: 58px;

        .combo-rank(@rankNo) {
          transform: translate(0, (@rankNo - 1) * @comboHeight);

          &.combo-enter-from{
            opacity: 0;
            transform: translate(-20px, (@rankNo - 1) * @comboHeight);
            transform-origin: left;
          }
        
          &.combo-leave-to {
            opacity: 0;
            transform: translate(0, (@rankNo - 1) * @comboHeight - 20px);
            transform-origin: center;
          }
        }

        &.rank-1 {
          .combo-rank(1);
        }
        &.rank-2 {
          .combo-rank(2);
        }
      }

      & > li:last-child .gift-combo {
        margin-bottom: 0;
      }
    }
  }

  
}
</style>